import { FC } from 'react'
import { SectionDoubleMediaWithBackgroundProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { MediaWithBackground, SectionWrapper } from '@portfolio/components'

const StyledSectionWrapper = styled(SectionWrapper, {
  display: 'grid',
  gap: '$96',
  containerSpace: 'none',
  '@lg': {
    gridTemplateColumns: '1fr 1fr',
    gap: '$32',
    containerSpace: 'medium',
  },
})

const CardWrap = styled('div', {
  display: 'grid',
  gap: '$20',
})

const Description = styled('p', {
  projectFont: 'body04',
  color: '$black_06',
})
const DescriptionContainer = styled('div', {
  containerSpace: 'medium',
  '@lg': {
    containerSpace: 'none',
  },
})
export const SectionDoubleMediaWithBackground: FC<
  SectionDoubleMediaWithBackgroundProps
> = ({ color, priority, mediaCards }) => {
  return (
    <StyledSectionWrapper type="MEDIA">
      {mediaCards?.map((card, index) => {
        return (
          card.media?.mediaPayload && (
            <CardWrap key={`media-${card.mediaDescription}-${index}`}>
              <MediaWithBackground
                media={card.media}
                color={color}
                priority={priority}
                mediaBorder={card.mediaBorder}
                sizes="(min-width: 1000px) 50vw, 100vw"
                appearance="doubleMedia"
              />
              <DescriptionContainer>
                {card.mediaDescription && (
                  <Description>↑ {card.mediaDescription}</Description>
                )}
              </DescriptionContainer>
            </CardWrap>
          )
        )
      })}
    </StyledSectionWrapper>
  )
}
